/**
 * Application-wide constants and enumerations.
 */

// ============================================================================
// ENVIRONMENT TYPE CONSTANTS
// ============================================================================

export const ENV_TYPE_DEV = 2;
export const ENV_TYPE_TEST = 0;
export const ENV_TYPE_PROD = 1;

export const ENV_TYPE_NAMES = {
  [ENV_TYPE_DEV]: "dev",
  [ENV_TYPE_TEST]: "test",
  [ENV_TYPE_PROD]: "prod"
};

// Valid environment type values
export const VALID_ENV_TYPES = [ENV_TYPE_DEV, ENV_TYPE_TEST, ENV_TYPE_PROD];


// ============================================================================
// SOURCE CONSTANTS
// ============================================================================

export const SOURCE_INVITE_CLARA = "invite-clara";
export const SOURCE_WTW_CLARA = "wtw-clara";

// Valid data source values
export const VALID_SOURCES = [SOURCE_INVITE_CLARA, SOURCE_WTW_CLARA];


// ============================================================================
// CATEGORY TYPE CONSTANTS
// ============================================================================

export const CATEGORY_TYPE_CLARA_RESPONSE = "clara_response_category";
export const CATEGORY_TYPE_USER_QUERY = "user_query_category";

// Valid category type values
export const VALID_CATEGORY_TYPES = [CATEGORY_TYPE_CLARA_RESPONSE, CATEGORY_TYPE_USER_QUERY];

